export default {
    mounted() {
        this.setTitle();
    },
    methods: {
        setTitle() {
            let {title} = this.$options;
            if(title !== undefined) {
                title = typeof title === 'function' ? title.call(this) : title;
    
                document.title = 'CoMS' + (title ? ` - ${title}` : '');
            }
        }
    }
}